import React from 'react';
import DatePicker from 'react-datepicker';
import { enGB } from 'date-fns/locale';
import ActionButtons from '../shared/ActionButtons';
import GenreSelector from '../shared/GenreSelector';
import ArtistSelector from '../shared/ArtistSelector';
import ArtistList from '../shared/ArtistList';

const ReleaseInfoTab = ({
  title,
  setTitle,
  artistRole,
  setArtistRole,
  artistName,
  setArtistName,
  artists,
  artists1,
  setArtists1,
  removeArtist1,
  primaryGenre,
  setPrimaryGenre,
  filterPrimaryGenres,
  primaryGenresList,
  secondaryGenre,
  setSecondaryGenre,
  filterSecondaryGenres,
  secondaryGenresList,
  originalDate,
  setOriginalDate,
  digitalDate,
  setDigitalDate,
  upc,
  setUpc,
  upcDisabled,
  setUpcDisabled,
  years,
  copyrightYear,
  setCopyrightYear,
  copyrightLine,
  setCopyrightLine,
  publishingYear,
  setPublishingYear,
  publishingLine,
  setPublishingLine,
  label,
  setLabel,
  filterLabels,
  labelsList,
  activeRadio,
  setActiveRadio,
  checkedCountries,
  setCheckedCountries,
  countries,
  handleCheckCountry,
  imgPreview,
  imgSrc,
  uploadLabel,
  fileInputRef,
  checkImg,
  removeImg,
  handleSave,
  isSaving,
  setTab
}) => {
  return (
    <div className="row px-2">
      <div className="col-12 px-1 mt-3">
        <div className="dash-form-group">
          <label>Title</label>
          <input 
            type="text" 
            placeholder='Release Title' 
            value={title} 
            onChange={(e) => setTitle(e.target.value)} 
            className='dash-form-input' 
          />
        </div>
      </div>
      <div className="col-lg-6">
        <ArtistSelector 
          artistRole={artistRole}
          setArtistRole={setArtistRole}
          artistName={artistName}
          setArtistName={setArtistName}
          artists={artists}
          addArtist={() => setArtists1([...artists1, {artistId: artistName.artistId, name: artistName.name, role: artistRole}])}
        />
        <div className="col-12 px-1">
          <ArtistList 
            artists={artists1} 
            removeArtist={removeArtist1} 
          />
        </div>
      </div>
      <div className="col-md-6 mt-3">
        <div className="dash-form-group">
          <label>Album Artwork</label>
          <div className="img-file-upload">
            {imgPreview && (
              <div className='img-preview'>
                <img src={imgSrc} alt="" />
                <i className="fi fi-rr-trash remove-artwork" onClick={removeImg}></i>
              </div>
            )}
            <div className="dash-form-file">
              <div className="height-equal"></div>
              <i className="fi fi-rr-cloud-upload"></i>
              {uploadLabel}
              <input type="file" ref={fileInputRef} onChange={checkImg} />
              <div className="height-equal"></div>
            </div>
            {!imgPreview && (
              <ul className="upload-requirements">
                <li><span>Size:</span> 1500px - 3000px (perfect square)</li>
                <li className='mt-1'><span>Format:</span> JPG or PNG (Max. 10 MB; RGB mode)</li>
              </ul>
            )}
          </div>
        </div>
      </div>
      <div className="col-12"></div>
      <div className="col-md-6">
        <div className="row">
          <div className="col-md-6 px-1 mt-3">
            <GenreSelector 
              label="Primary Genre"
              genre={primaryGenre}
              genresList={primaryGenresList}
              onChange={filterPrimaryGenres}
              onSelect={setPrimaryGenre}
            />
          </div>
          <div className="col-md-6 px-1 mt-3">
            <GenreSelector 
              label="Secondary Genre"
              genre={secondaryGenre}
              genresList={secondaryGenresList}
              onChange={filterSecondaryGenres}
              onSelect={setSecondaryGenre}
            />
          </div>
          <div className="col-md-6 px-1 mt-3">
            <div className="dash-form-group">
              <label>Original Release Date</label>
              <DatePicker
                id="date-picker"
                selected={originalDate}
                onChange={e => setOriginalDate(e)}
                dateFormat="yyyy/MM/dd"
                locale={enGB} 
                className='dash-form-input'
              />
            </div>
          </div>
          <div className="col-md-6 px-1 mt-3">
            <div className="dash-form-group">
              <label>Digital Release Date</label>
              <DatePicker
                id="date-picker"
                selected={digitalDate}
                onChange={e => setDigitalDate(e)}
                dateFormat="yyyy/MM/dd"
                locale={enGB} 
                className='dash-form-input'
              />
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-6 px-1 mt-3">
        <div className="dash-form-group">
          <label>UPC</label>
          <input 
            type="text" 
            placeholder='UPC' 
            value={upc} 
            onChange={(e) => setUpc(e.target.value)} 
            className={`dash-form-input ${upcDisabled && 'disabled'}`} 
            disabled={upcDisabled} 
          />
        </div>
        <div className="form-check dash-form-check mt-2">
          <input 
            className="form-check-input" 
            onChange={() => setUpcDisabled(!upcDisabled)} 
            type="checkbox" 
            id="upc" 
          />
          <label className="form-check-label" htmlFor="upc">
            I don't have one, assign a UPC code to this release automatically
          </label>
        </div>
      </div>
      <div className="col-lg-6">
        <div className="row">
          <div className="col-12 px-1 mt-3">
            <div className="dash-form-group">
              <label>Copyright</label>
              <div className="d-flex">
                <select 
                  value={copyrightYear} 
                  onChange={(e) => setCopyrightYear(e.target.value)} 
                  className='dash-form-select dash-copy-year'
                >
                  {years.map(year => (
                    <option key={year}>{year}</option>
                  ))}
                </select>
                <input 
                  type="text" 
                  value={copyrightLine} 
                  onChange={(e) => setCopyrightLine(e.target.value)} 
                  placeholder='Copyright Line' 
                  className='dash-form-input dash-copy-line' 
                />
              </div>
            </div>
          </div>
          <div className="col-12 px-1 mt-3">
            <div className="dash-form-group">
              <label>Publishing</label>
              <div className="d-flex">
                <select 
                  value={publishingYear} 
                  onChange={(e) => setPublishingYear(e.target.value)} 
                  className='dash-form-select dash-copy-year'
                >
                  {years.map(year => (
                    <option key={year}>{year}</option>
                  ))}
                </select>
                <input 
                  type="text" 
                  value={publishingLine} 
                  onChange={(e) => setPublishingLine(e.target.value)} 
                  placeholder='Publishing Line' 
                  className='dash-form-input dash-copy-line' 
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-6">
        <div className="row">
          <div className="col-12 px-1 mt-3">
            <div className="dash-form-group">
              <label>Label</label>
              <div className="dropdown dash-form-dropdown">
                <input 
                  type="text" 
                  className='dash-form-input' 
                  placeholder='Select label' 
                  data-bs-toggle="dropdown" 
                  aria-expanded="false"
                  value={label}
                  onChange={filterLabels}
                />
                <ul className="dropdown-menu">
                  {labelsList.map((item, i) => (
                    <li key={i} onClick={() => setLabel(item.name)}>
                      {item.name}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div className="col-12 px-1 mt-3">
            <div className="dash-form-group">
              <label>Territories</label>
              <div className="form-check dash-form-check">
                <input 
                  className="form-check-input" 
                  checked={activeRadio === 1} 
                  onChange={() => {setActiveRadio(1); setCheckedCountries(['Worldwide'])}} 
                  type="radio" 
                  name="territory" 
                  id="territory1" 
                />
                <label className="form-check-label" htmlFor="territory1">
                  Worldwide
                </label>
              </div>
              <div className="form-check dash-form-check">
                <input 
                  className="form-check-input" 
                  checked={activeRadio === 2} 
                  onChange={() => {setActiveRadio(2); setCheckedCountries([])}} 
                  type="radio" 
                  name="territory" 
                  id="territory2" 
                />
                <label className="form-check-label" htmlFor="territory2">
                  Select countries
                </label>
              </div>
            </div>
            {activeRadio === 2 && (
              <div className="dash-form-group mt-3">
                <div className="dropdown dash-form-dropdown">
                  <button className="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    Countries
                  </button>
                  <ul className="dropdown-menu">
                    {countries.map((country, i) => (
                      <li className='form-check' key={i}>
                        <input 
                          className="form-check-input" 
                          onChange={(e) => handleCheckCountry(country, e)} 
                          checked={checkedCountries.includes(country)}
                          type="checkbox" 
                        />
                        {country}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="col-12 px-1 mt-3">
        <ActionButtons 
          onSave={handleSave}
          onNext={() => setTab(2)}
          isSaving={isSaving}
        />
      </div>
    </div>
  );
};

export default ReleaseInfoTab; 